// The JSON import of artists, places and shows: the import dialogs, and why an imported item is refused
const en = {
  importFailed: 'Import failed',
  importFinished: 'Import finished',
  parseError: 'Error parsing JSON file. Please check the file format.',
  /** An imported item without a name */
  unknown: 'Unknown',
  artistMissingFields: (name: string, fields: string) => `Artist "${name}" is missing required fields: ${fields}`,
  /** `platform` is a brand name: Spotify, Apple Music… */
  invalidLink: (platform: string, artist: string) => `Invalid ${platform} URL for artist "${artist}"`,
  invalidOtherLink: (artist: string) => `Invalid Other URL for artist "${artist}"`,
  poiMissingFields: (name: string, fields: string) => `POI "${name}" is missing required fields: ${fields}`,
  poiUnknownMap: (name: string, map: string) => `POI "${name}" references non-existent map: ${map}`,
  poiInvalidCoordinates: (name: string) => `POI "${name}" has invalid coordinates`,
  showMissingFields: (fields: string) => `Show is missing required fields: ${fields}`,
  showUnknownArtist: (artist: string) => `Show references non-existent artist: ${artist}`,
  showUnknownScene: (scene: string) => `Show references non-existent scene: ${scene}`,
  showInvalidDates: 'Show has invalid dates',
  showEndsBeforeStart: 'Show end date must be after start date',
  showInvalidDateFormat: 'Show has invalid date format',
};

const fr: typeof en = {
  importFailed: 'Échec de l\'import',
  importFinished: 'Import terminé',
  parseError: 'Impossible de lire le fichier JSON. Vérifiez son format.',
  unknown: 'Inconnu',
  artistMissingFields: (name, fields) => `Champs obligatoires manquants pour l'artiste «\u00a0${name}\u00a0»\u00a0: ${fields}`,
  invalidLink: (platform, artist) => `URL ${platform} invalide pour l'artiste «\u00a0${artist}\u00a0»`,
  invalidOtherLink: artist => `Autre URL invalide pour l'artiste «\u00a0${artist}\u00a0»`,
  poiMissingFields: (name, fields) => `Champs obligatoires manquants pour le lieu «\u00a0${name}\u00a0»\u00a0: ${fields}`,
  poiUnknownMap: (name, map) => `Le lieu «\u00a0${name}\u00a0» fait référence à un plan inexistant\u00a0: ${map}`,
  poiInvalidCoordinates: name => `Le lieu «\u00a0${name}\u00a0» a des coordonnées invalides`,
  showMissingFields: fields => `Champs obligatoires manquants pour le show\u00a0: ${fields}`,
  showUnknownArtist: artist => `Le show fait référence à un artiste inexistant\u00a0: ${artist}`,
  showUnknownScene: scene => `Le show fait référence à une scène inexistante\u00a0: ${scene}`,
  showInvalidDates: 'Le show a des dates invalides',
  showEndsBeforeStart: 'La date de fin du show doit être après sa date de début',
  showInvalidDateFormat: 'Les dates du show ont un format invalide',
};

const messages = { en, fr };
export default messages;
